import _slicedToArray from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as S from "./styles";
import Input from "./../../Input";
import { Row, Col } from "./../../Grid";
import { Dropdown } from "./../../Dropdown";
import { trim, validateEmail, validateNotEmpty, getErrorMessage, getNestedProp, USER_ID_FORMAT_REGEX } from "./../../../shared/formUtils";
var defaultValidations = {
  firstName: {
    required: "Please enter valid first name",
    validate: function validate(e) {
      return validateNotEmpty(e) || "Please enter valid first name";
    }
  },
  lastName: {
    required: "Please enter valid last name",
    validate: function validate(e) {
      return validateNotEmpty(e) || "Please enter valid last name";
    }
  },
  dob: {
    required: "Please enter valid date"
  },
  state: {
    required: "Please select a valid state"
  },
  email: {
    validate: function validate(e) {
      return validateEmail(e);
    },
    required: "Please enter a valid email"
  },
  thirdPartyId: {
    required: "Please enter a valid ID",
    validate: function validate(e) {
      return validateNotEmpty(e) || "Please enter a valid ID";
    }
  },
  confirmThirdPartyId: {
    required: !0,
    validate: function validate(e) {
      return validateNotEmpty(e);
    }
  }
};
export function PersonalInformation(_ref) {
  var e = _ref.firstName,
      a = _ref.lastName,
      t = _ref.dob,
      _ref$shippableStates = _ref.shippableStates,
      r = _ref$shippableStates === void 0 ? [] : _ref$shippableStates,
      l = _ref.email,
      i = _ref.thirdPartyId,
      o = _ref.confirmThirdPartyId,
      d = _ref.uniqueId,
      n = _ref.normalizeDate,
      s = _ref.normalizeEmployeeId,
      m = _ref.isValidDate,
      c = _ref.isValidState,
      u = _ref.isValidId,
      f = _ref.onSubmit,
      p = _ref.onCancel,
      _ref$liteDisplay = _ref.liteDisplay,
      E = _ref$liteDisplay === void 0 ? !1 : _ref$liteDisplay,
      _ref$displayCancelBut = _ref.displayCancelButton,
      h = _ref$displayCancelBut === void 0 ? !0 : _ref$displayCancelBut;

  var _useForm = useForm({
    defaultValues: {
      firstName: e,
      lastName: a,
      dob: t,
      email: l,
      thirdPartyId: i,
      confirmThirdPartyId: o
    }
  }),
      I = _useForm.register,
      y = _useForm.setValue,
      P = _useForm.handleSubmit,
      R = _useForm.errors,
      v = _useForm.watch,
      _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      g = _useState2[0],
      b = _useState2[1],
      N = E ? 12 : 6,
      C = v(),
      D = (null == d ? void 0 : d.format) || USER_ID_FORMAT_REGEX;

  return React.createElement(S.FormContainer, {
    onSubmit: P(function () {
      return b(!0), f(C);
    })
  }, React.createElement(Row, null, React.createElement(Col, {
    xs: 12,
    sm: N
  }, React.createElement(Input, {
    id: "firstName",
    name: "firstName",
    label: "First Name",
    placeholder: "First Name",
    ref: I(defaultValidations.firstName),
    error: getNestedProp(R, ["firstName", "message"])
  })), React.createElement(Col, {
    xs: 12,
    sm: N
  }, React.createElement(Input, {
    id: "lastName",
    name: "lastName",
    label: "Last Name",
    placeholder: "Last Name",
    ref: I(defaultValidations.lastName),
    error: getNestedProp(R, ["lastName", "message"])
  }))), React.createElement(Row, null, React.createElement(Col, null, React.createElement(Input, {
    id: "email",
    name: "email",
    label: "Email",
    placeholder: "johndoe@email.com",
    ref: I(defaultValidations.email),
    error: getErrorMessage(R, ["email"], defaultValidations),
    onChange: function onChange(e) {
      return y("email", trim(e.target.value));
    }
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12,
    sm: N
  }, React.createElement(Input, {
    id: "dob",
    name: "dob",
    label: "Date of Birth",
    placeholder: "MM/DD/YYYY",
    ref: I(Object.assign(Object.assign({}, defaultValidations.dob), {
      validate: function validate(e) {
        return m && m(e);
      }
    })),
    error: getErrorMessage(R, ["dob"], defaultValidations),
    onChange: function onChange(e) {
      if (n) {
        var _a = n(e.target.value);

        y("dob", _a);
      }
    }
  })), !E && React.createElement(Col, {
    xs: 12,
    sm: N
  }, React.createElement(Dropdown, {
    items: r,
    id: "state",
    name: "state",
    label: "Select State",
    placeholderText: "Select State",
    showErrorMessage: !0,
    error: getErrorMessage(R, ["state"], defaultValidations),
    ref: I(Object.assign(Object.assign({}, defaultValidations.state), {
      validate: function validate(e) {
        return c && c(e);
      }
    }))
  }))), d && !!d.required && React.createElement(Row, null, React.createElement(Col, {
    xs: 12,
    sm: N
  }, React.createElement(Input, {
    id: "thirdPartyId",
    name: "thirdPartyId",
    label: (null == d ? void 0 : d.label) || "Third Party ID",
    placeholder: "ID associated to you",
    ref: I({
      required: !0,
      validate: function validate(e) {
        return u && u(e, D);
      }
    }),
    error: getErrorMessage(R, ["thirdPartyId"], defaultValidations),
    onChange: function onChange(e) {
      if (s) {
        var _a2 = s(e.target.value, i || "", D);

        y("thirdPartyId", _a2);
      }
    }
  })), React.createElement(Col, {
    xs: 12,
    sm: N
  }, React.createElement(Input, {
    id: "confirmThirdPartyId",
    name: "confirmThirdPartyId",
    label: "Confirm " + ((null == d ? void 0 : d.label) ? d.label : "Third Party ID"),
    placeholder: "Re-enter ID",
    ref: I({
      required: !0,
      validate: function validate(e) {
        return function (e) {
          return C.thirdPartyId === e;
        }(e);
      }
    }),
    error: C.thirdPartyId !== C.confirmThirdPartyId ? "IDs do not match. Please try again." : "",
    onChange: function onChange(e) {
      if (s) {
        var _a3 = s(e.target.value, "", D);

        y("confirmThirdPartyId", _a3);
      }
    }
  }))), React.createElement(S.ButtonGroupContainer, {
    reverse: !0,
    liteDisplay: E
  }, React.createElement(S.PrimaryButton, {
    hasArrow: !0,
    isLoading: g,
    appearance: "primary",
    disabled: g || !C.dob || !C.email || !C.firstName || !C.lastName || d && d.required && (!C.thirdPartyId || !C.confirmThirdPartyId)
  }, "Continue"), p && h && React.createElement(S.SecondaryButton, {
    onClick: p,
    appearance: "secondary"
  }, "Cancel")));
}
export default PersonalInformation;